import { render, staticRenderFns } from "./SelectPoint.vue?vue&type=template&id=84e22362&scoped=true"
import script from "./SelectPoint.vue?vue&type=script&lang=js"
export * from "./SelectPoint.vue?vue&type=script&lang=js"
import style0 from "./SelectPoint.vue?vue&type=style&index=0&id=84e22362&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e22362",
  null
  
)

export default component.exports